/* eslint-disable */
export default {
    keyExists(key, obj) {
        var parts = key.split('.');
        var ref = obj;
        var result = true;
        for (var i = 0; i < parts.length; i++) {
            var item = parts[i];
            if (!(item in ref)) {
                result = false;
                break;
            }
            ref = ref[item];
        }
        return result;
    },
    isIterable(obj) {
        return Array.isArray(obj) || obj !== null && typeof obj === 'object';
    },
    extend() {
        for (var i=1; i < arguments.length; i++) {
            for (var key in arguments[i]) {
                if(arguments[i].hasOwnProperty(key)) {
                    if (typeof arguments[0][key] === 'object' && typeof arguments[i][key] === 'object') {
                        this.extend(arguments[0][key], arguments[i][key]);
                    }
                    else {
                        arguments[0][key] = arguments[i][key];
                    }
                }
            }
        }
        return arguments[0];
    },
    objectLength(obj) {
        var count = 0;
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                count++;
            }
        }
        return count;
    },
    post(url, data) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let request = new XMLHttpRequest();

            for (let key in data) {
                let value = data[key];

                if (value === null) {
                    continue;
                }

                if (Array.isArray(value)) {
                    for (let i = 0; i < value.length; i++) {
                        let arrayValue = value[i];

                        for (let arrayItem in arrayValue) {
                            let arrayData = arrayValue[arrayItem];
                            formData.set(key + '[' + i + ']' +  '[' + arrayItem + ']', arrayData);
                        }
                    }
                } else if (typeof value === 'object' && value !== null) {
                    for (let objectKey in value) {
                        let objectData = value[objectKey];
                        formData.set(key + '[' + objectKey + ']', objectData);
                    }
                } else {
                    formData.set(key, value);
                }
            }

            request.open("POST", url);
            request.onreadystatechange = (e) => {
                let target = e.target;
                let readyState = target.readyState;
                let status = target.status;

                if (readyState === 4) {
                    if (status === 200) {
                        resolve(target.response);
                    } else {
                        reject(target.response);
                    }
                }
            };
            request.send(formData);
        });
    }
}
